module.exports = __webpack_public_path__ + "static/L2_ux_4_eg-b07a24329c49eeae2760a755e1e2e787.png";